import { CustomSelectFieldProps, SelectField } from 'components/form'
import { UnidadePeriodoRelatorioGerencialEnum } from 'graphql/types.generated'

type RelatorioGerencialUnidadePeriodoSelectFieldProps = CustomSelectFieldProps<UnidadePeriodoRelatorioGerencialEnum>

const items: UnidadePeriodoRelatorioGerencialEnum[] = Object.values(UnidadePeriodoRelatorioGerencialEnum)

const unidadeMedidaLabel: Record<UnidadePeriodoRelatorioGerencialEnum, string> = {
  [UnidadePeriodoRelatorioGerencialEnum.DIA]: 'Personalizado',
  [UnidadePeriodoRelatorioGerencialEnum.SEMANA]: 'Semanal',
  [UnidadePeriodoRelatorioGerencialEnum.MES]: 'Mensal',
}

const itemToString = (item: UnidadePeriodoRelatorioGerencialEnum) => unidadeMedidaLabel[item]

export function RelatorioGerencialUnidadePeriodoSelectField(props: RelatorioGerencialUnidadePeriodoSelectFieldProps) {
  return (
    <SelectField<UnidadePeriodoRelatorioGerencialEnum>
      items={items}
      itemToString={itemToString}
      clearable={false}
      {...props}
    />
  )
}
